module.exports = __webpack_public_path__ + "img/single-account.7a8113a9.svg";